import { cType, PollutantType } from './store';
export function getPollutantTypeFromCondition(conditionType) {
    switch (conditionType) {
        case cType.PM2_5:
            return PollutantType.PM2_5;
        case cType.PM10:
            return PollutantType.PM10;
        case cType.OZONE:
            return PollutantType.OZONE;
        case cType.AQI:
            return PollutantType.AQI;
    }
}
export function getPollutantDisplayName(pollutantType) {
    switch (pollutantType) {
        case PollutantType.PM2_5:
            return 'PM2.5';
        case PollutantType.PM10:
            return 'PM10';
        case PollutantType.OZONE:
            return 'Ozone';
        case PollutantType.AQI:
            return 'AQI';
    }
}
